import React, { useState } from "react";
import { format } from "date-fns";
import { motion } from "framer-motion";
import { useCookies } from "react-cookie";
var item = {
    hidden: {
        y: 0,
        opacity: 1,
    },
};
function isArrayOfStrings(value) {
    return Array.isArray(value) && value.every(function (item) { return typeof item === "string"; });
}
export var ChatItem = function (_a) {
    var message = _a.message, user = _a.user;
    var _b = useState(false), hover = _b[0], setHover = _b[1];
    var _c = useCookies(["STREAMY_CHAT_BLOCKED_USERS"]), cookies = _c[0], setCookie = _c[1];
    var IgnoreUser = function (userId) {
        if (cookies.STREAMY_CHAT_BLOCKED_USERS && isArrayOfStrings(cookies.STREAMY_CHAT_BLOCKED_USERS)) {
            var newCookie = cookies.STREAMY_CHAT_BLOCKED_USERS;
            newCookie.push(userId);
            setCookie("STREAMY_CHAT_BLOCKED_USERS", newCookie);
        }
        else {
            setCookie("STREAMY_CHAT_BLOCKED_USERS", [userId]);
        }
    };
    return message.type === "chat" ? (React.createElement(motion.div, { variants: item, initial: { y: 10, opacity: 0 }, transition: { duration: 0.1 }, className: "relative chat-item w-3/4 my-2 p-2 rounded-sm mobile:w-10/12 clearfix break-words " + (user.userId === message.user.id
            ? "bg-brand-green-tertiary self-end chat-item-self"
            : "bg-brand-blue-tertiary chat-item-other"), onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
        message.user.status === "verified" && (
        // verified-ikon
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-5 right-0 top-0 -mt-3 -mr-3 text-brand-blue-primary absolute " + (user.userId === message.user.id ? " left-0 top-0 -mt-3 -ml-3 " : " right-0 top-0 -mt-3 -mr-3 ") },
            React.createElement("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }))),
        user.userId !== message.user.id && hover && (
        // mute-ikon
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-5 right-0 top-0 mt-1 text-gray-400 opacity-100 absolute top-0 mr-1 z-10 hover:cursor-pointer", onClick: function () { return IgnoreUser(message.user.id); }, "aria-label": "hide all messages from this user" },
            React.createElement("path", { fillRule: "evenodd", d: "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z", clipRule: "evenodd" }))),
        React.createElement("span", { className: "text-gray-500" }, format(new Date(message.timestamp * 1000), "HH:mm")),
        " ",
        React.createElement("strong", { className: "relative" },
            " ",
            message.user.displayName,
            ": "),
        message.text)) : (React.createElement(motion.div, { variants: item, initial: { y: 10, opacity: 0 }, className: "chat-item clearfix bg-red-300 w-full my-2 p-2 rounded-sm" }, message.text));
};
//# sourceMappingURL=ChatItem.js.map